import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ShadowTestResponse, Stage } from "../lusca-search-api/generated-src";
import { ShadowTestApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";

interface ShadowTestParams {
  stage: Stage;
  marketplace: string;
  glProductGroupId: string;
  transactionIds: string[];
}

interface ShadowTestResult {
  isLoading: boolean;
  error: Error | null;
  transactionsCount?: number;
  trigger: (params: ShadowTestParams) => void;
}

export default function useShadowTest(): ShadowTestResult {
  const shadowTestApi = ShadowTestApiFactory();

  const { mutate, isLoading, error, data } = useMutation<
    ShadowTestResponse,
    Error,
    ShadowTestParams
  >(
    async ({ stage, marketplace, glProductGroupId, transactionIds }) => {
      const { data }: AxiosResponse<ShadowTestResponse> =
        await shadowTestApi.createShadowTest(stage, {
          marketplace,
          glProductGroupId,
          transactionIds,
        });
      return data;
    },
    {
      onError: (error) => {
        console.error("Shadow test error:", error);
      },
      onSuccess: (data) => {
        console.log("Shadow test initiated:", data);
      },
    }
  );

  const trigger = (params: ShadowTestParams) => {
    mutate(params);
  };

  return {
    isLoading,
    error: error || null,
    transactionsCount: data?.transactionsCount,
    trigger,
  };
}
